// SPDX-License-Identifier: AGPL-3.0-or-later

// Generated by tools/room_themes/build_manifest.mjs from validated room GLB files. Do not edit by hand.

export interface VoiceRoomThemeManifestEntry {
	readonly file: string;
	readonly bytes: number;
	readonly seats: ReadonlyArray<string>;
	readonly watch_seats: ReadonlyArray<string>;
	readonly tables: ReadonlyArray<{readonly slot: string; readonly seats: 4}>;
	readonly stands: number;
	readonly variants?: {readonly 1024: string};
	readonly effects?: ReadonlyArray<{readonly kind: 'campfire' | 'projector' | 'fireflies'; readonly node: string}>;
}

export const VOICE_ROOM_THEME_MANIFEST = {
	'gece-lounge': {
		file: 'gece-lounge.44d93cd99ba8.mglb',
		bytes: 2418356,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_A_07',
			'seat_A_08',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
			'seat_C_04',
			'seat_D_01',
			'seat_D_02',
			'seat_D_03',
			'seat_D_04',
			'seat_D_05',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T01_Y3', 'seat_T01_Y4'],
		tables: [{slot: 'T01', seats: 4}],
		stands: 12,
		variants: {1024: 'gece-lounge-1024.614a9f93bc13.mglb'},
	},
	kahvehane: {
		file: 'kahvehane.7fadb44ea550.mglb',
		bytes: 2311636,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_C_01',
			'seat_C_02',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T02_Y1', 'seat_T02_Y2', 'seat_T03_Y1', 'seat_T03_Y2'],
		tables: [
			{slot: 'T01', seats: 4},
			{slot: 'T02', seats: 4},
			{slot: 'T03', seats: 4},
		],
		stands: 12,
		variants: {1024: 'kahvehane-1024.68d3d9f4cd5d.mglb'},
	},
	'kamp-atesi': {
		file: 'kamp-atesi.016bb46c2ef2.mglb',
		bytes: 2998220,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_A_07',
			'seat_A_08',
			'seat_A_09',
			'seat_A_10',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_B_05',
			'seat_B_06',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
			'seat_C_04',
			'seat_C_05',
			'seat_C_06',
			'seat_D_01',
			'seat_D_02',
			'seat_D_03',
			'seat_D_04',
			'seat_D_05',
			'seat_D_06',
			'seat_E_01',
			'seat_E_02',
			'seat_E_03',
			'seat_E_04',
			'seat_E_05',
			'seat_E_06',
			'seat_F_01',
			'seat_F_02',
			'seat_F_03',
			'seat_F_04',
			'seat_F_05',
			'seat_F_06',
		],
		watch_seats: ['seat_T01_Y1', 'seat_T01_Y2', 'seat_T01_Y3', 'seat_T01_Y4'],
		tables: [{slot: 'T01', seats: 4}],
		stands: 21,
		variants: {1024: 'kamp-atesi-1024.63dc45165ffd.mglb'},
		effects: [
			{kind: 'campfire', node: 'fx_campfire'},
			{kind: 'fireflies', node: 'fx_fireflies_01'},
			{kind: 'fireflies', node: 'fx_fireflies_02'},
			{kind: 'fireflies', node: 'fx_fireflies_03'},
			{kind: 'fireflies', node: 'fx_fireflies_04'},
			{kind: 'fireflies', node: 'fx_fireflies_05'},
			{kind: 'fireflies', node: 'fx_fireflies_06'},
			{kind: 'fireflies', node: 'fx_fireflies_07'},
		],
	},
	'oyun-odasi': {
		file: 'oyun-odasi.4a23cf090a56.mglb',
		bytes: 2244036,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
		],
		watch_seats: [
			'seat_T01_Y1',
			'seat_T01_Y2',
			'seat_T01_Y3',
			'seat_T01_Y4',
			'seat_T02_Y1',
			'seat_T02_Y2',
			'seat_T02_Y3',
			'seat_T02_Y4',
		],
		tables: [
			{slot: 'T01', seats: 4},
			{slot: 'T02', seats: 4},
		],
		stands: 12,
		variants: {1024: 'oyun-odasi-1024.ed9b1877ad8d.mglb'},
	},
	sinema: {
		file: 'sinema.8a1bd2aa7f09.mglb',
		bytes: 1874520,
		seats: [
			'seat_A_01',
			'seat_A_02',
			'seat_A_03',
			'seat_A_04',
			'seat_A_05',
			'seat_A_06',
			'seat_A_07',
			'seat_A_08',
			'seat_B_01',
			'seat_B_02',
			'seat_B_03',
			'seat_B_04',
			'seat_B_05',
			'seat_B_06',
			'seat_B_07',
			'seat_B_08',
			'seat_C_01',
			'seat_C_02',
			'seat_C_03',
			'seat_C_04',
			'seat_C_05',
			'seat_C_06',
			'seat_C_07',
			'seat_C_08',
			'seat_D_01',
			'seat_D_02',
			'seat_D_03',
			'seat_D_04',
			'seat_D_05',
			'seat_D_06',
			'seat_D_07',
			'seat_D_08',
			'seat_E_01',
			'seat_E_02',
			'seat_E_03',
			'seat_E_04',
			'seat_E_05',
			'seat_E_06',
			'seat_E_07',
			'seat_E_08',
			'seat_F_01',
			'seat_F_02',
			'seat_F_03',
			'seat_F_04',
			'seat_F_05',
			'seat_F_06',
			'seat_F_07',
			'seat_F_08',
			'seat_G_01',
			'seat_G_02',
			'seat_G_03',
			'seat_G_04',
			'seat_G_05',
			'seat_G_06',
		],
		watch_seats: [],
		tables: [],
		stands: 12,
		variants: {1024: 'sinema-1024.0c0ed2cc0426.mglb'},
		effects: [{kind: 'projector', node: 'fx_projector'}],
	},
} as const satisfies Record<string, VoiceRoomThemeManifestEntry>;
